export default function($stateProvider) {
    $stateProvider
        .state('radniNalog', {
            url: '/radniNalog',
            component: 'radniNalogList',
            data: {
                pageTitle: 'Radni nalozi'
            }
        })

        .state('radniNalog.details', {
            url: '/details/:id',
            views: {
                '@': {
                    // template: '<ordinacija-details></ordinacija-details>',
                    component: 'radniNalogDetails'
                }
            },
            resolve: {
                id: [
                    '$transition$',
                    'DS',
                    function($transition$, DS) {
                        const params = $transition$.params();
                        return params.id;
                    }
                ]
            },
            data: {
                pageTitle: 'Pregled naloga'
            }
        })

        .state('radniNalog.details.edit', {
            url: '/edit',
            views: {
                '@': {
                    component: 'radniNalogEdit'
                }
            },
            resolve: {
                item: [
                    'DS',
                    '$transition$',
                    (DS, $transition$) => {
                        const params = $transition$.params();
                        return DS.find('RadniNalog', params.id);
                    }
                ]
            }
        })

        .state('radniNalog.details.planRada', {
            url: '/planRada',
            views: {
                '@': {
                    component: 'planRada'
                }
            },
            data: {
                pageTitle: 'Plan rada'
            }
        })

        .state('radniNalog.create', {
            url: '/create',
            views: {
                '@': {
                    component: 'radniNalogCreate'
                }
            }
        });
}



// WEBPACK FOOTER //
// ./app/components/radniNalog/states.js